import { get, map } from 'lodash';

import Model from 'models';

const CardCarouselModel = class extends Model {
  get type() {
    return get(this._data, '_contentType');
  }

  get heading() {
    return get(this._data, 'heading');
  }

  get subheading() {
    return get(this._data, 'subheading');
  }

  get isHeadingCentered() {
    return !!get(this._data, 'isHeadingCentered');
  }

  get isInverted() {
    return !!get(this._data, 'isInverted');
  }

  get carouselCards() {
    const data = get(this._data, 'carouselCards');

    return map(data, card => ({
      image: {
        src: get(card, ['image', 'file', 'url']),
        alt: get(card, ['image', 'description']),
        width: get(card, ['image', 'file', 'details', 'image', 'width']),
        height: get(card, ['image', 'file', 'details', 'image', 'height']),
      },
      heading: get(card, 'heading'),
      subheading: get(card, 'subheading'),
      subText: get(card, 'subText'),
      linkUrl: get(card, 'linkUrl', ''),
      videoUrl: get(card, ['video', 'file', 'url'], ''),
      type: get(card, '_contentType'),
      cardLabel: get(card, 'cardLabel'),
    }));
  }
};

export default CardCarouselModel;
